<!-- 检验模型流程 -->
<template>
  <div class="verification-model-process">
    <div class="verification-model-process-header">
      <i class="line"></i>
      <h4 class="title">检验模型主要流程</h4>
    </div>
    <div class="verification-model-process-content">
      <ul>
        <li :class="[currentProcess === '数据归一化'?'current-process':'']" @click="onSelectProcess('数据归一化')" v-if="modelType == 1 || modelType == 2">数据归一化</li>
        <li :class="[currentProcess === '数据归一化'?'current-process':'']" @click="onSelectProcess('数据归一化')" v-if="modelType == 5 || modelType == 6">特征提取</li>
        <i class="icon-right-arrow" v-if="modelType == 1 || modelType == 2 || modelType == 5 || modelType == 6"></i>
        <li :class="[currentProcess === '导入模型'?'current-process':'']" @click="onSelectProcess('导入模型')">导入模型</li>
        <i class="icon-right-arrow"></i>
        <li :class="[currentProcess === '预测结果并输出'?'current-process':'']" @click="onSelectProcess('预测结果并输出')">预测结果并输出</li>
      </ul>

      <!-- 代码编写区 -->
      <div class="content-text">
        <div class="content-text-one" v-if="currentProcess === '数据归一化' && (modelType == 1 || modelType == 2)">
          <p>train_images <i class="text-navy-blue">=</i> <i class="text-blue">train_images / 255.0</i></p>
        </div>
        
        <div class="content-text-one" v-if="currentProcess === '数据归一化' && (modelType == 5 || modelType == 6)">
          <p><i class="text-blue">def</i> <i class="text-pink">get_melspectrogram_layer</i> <i class="text-navy-blue">(</i></p>
          <p>input_shape <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 模型输入形状</i></p>
          <p>n_fft <i class="text-navy-blue">=</i> <i class="text-red">2048</i>, <i class="text-green"># 快速傅里叶变化点数</i></p>
          <p>win_length <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 短时傅里叶变换时窗长度</i></p>
          <p>hop_length <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 短时傅里叶变换跳长</i></p>
          <p>window_name <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>pad_begin <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>pad_end <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>sample_rate <i class="text-navy-blue">=</i> <i class="text-red">22050</i>, <i class="text-green"># 采样率</i></p>
          <p>n_mels <i class="text-navy-blue">=</i> <i class="text-red">128</i>, <i class="text-green"># 梅尔容器所在梅尔过滤器组的数目</i></p>
          <p>mel_f_min <i class="text-navy-blue">=</i> <i class="text-red">0.0</i>, <i class="text-green"># 梅尔过滤器组的最低频</i></p>
          <p>mel_f_max <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 梅尔过滤器组的最高频</i></p>
          <p>mel_htk <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>mel_norm <i class="text-navy-blue">=</i> <i class="text-blue">'slaney'</i>, <i class="text-green"># 梅尔滤波器组三角归一化策略</i></p>
          <p>return_decibel <i class="text-navy-blue">=</i> <i class="text-blue">False</i>,</p>
          <p>db_amin <i class="text-navy-blue">=</i> <i class="text-red">1e-5</i>, <i class="text-green"># 分贝缩放输入的噪声下限</i></p>
          <p>db_ref_value <i class="text-navy-blue">=</i> <i class="text-red">1.0</i>, <i class="text-green"># 分贝标度的参考值</i></p>
          <p>db_dynamic_range <i class="text-navy-blue">=</i> <i class="text-red">80.0</i>, <i class="text-green"># 分贝缩放结果的动态范围值</i></p>
          <p>input_data_format <i class="text-navy-blue">=</i> <i class="text-blue">'default'</i>,</p>
          <p>output_data_format <i class="text-navy-blue">=</i> <i class="text-blue">'default'</i>,</p>
          <p>name <i class="text-navy-blue">=</i> <i class="text-blue">'melspectrogram'</i>,</p>
          <p class="text-navy-blue">) : </p>
        </div>

        <div class="content-text-two" v-if="currentProcess === '导入模型'">
          <p><i class="text-blue">def</i> <i class="text-pink">load_model</i> <i class="text-navy-blue">(</i></p>
          <p>filepath, <i class="text-green"># hdf5模型路径</i></p>
          <p>custom_objects <i class="text-navy-blue">=</i> <i class="text-blue">None</i>,</p>
          <p>compile <i class="text-navy-blue">=</i> <i class="text-blue">True</i>,</p>
          <p>options <i class="text-navy-blue">=</i> <i class="text-blue">None</i> <i class="text-navy-blue">) ：</i></p>
        </div>

        <div class="content-text-three" v-if="currentProcess === '预测结果并输出' && (modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5 || modelType == 6)">
          <p><i class="text-blue">def</i> <i class="text-pink">evaluate</i> <i class="text-navy-blue">(</i></p>
          <p>self,</p>
          <p>x <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># {{modelType == 1 ? '输入图像数据':'输入文本数据'}}</i></p>
          <p>y <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 目标数据</i></p>
          <p>batch_size <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 批数</i></p>
          <p>verbose <i class="text-navy-blue">=</i> <i class="text-red">1</i>, <i class="text-green"># 信息复杂度模式，默认为1</i></p>
          <p>sample_weight <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 样本权重</i></p>
          <p>steps <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 步数</i></p>
          <p>callbacks <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 回调</i></p>
          <p>max_queue_size <i class="text-navy-blue">=</i> <i class="text-red">10</i>, <i class="text-green"># 队列最大值</i></p>
          <p>workers <i class="text-navy-blue">=</i> <i class="text-red">1</i>, <i class="text-green"># 进程数</i></p>
          <p>use_multiprocessing <i class="text-navy-blue">=</i> <i class="text-blue">False</i>, <i class="text-green"># 是否多进程处理</i></p>
          <p>return_dict <i class="text-navy-blue">=</i> <i class="text-blue">False</i></p>
          <p class="text-navy-blue">) : <i class="text-green"># 返回值是否为dict形式</i></p>
          <p>......</p>
        </div>

        <div class="content-text-three" v-if="currentProcess === '预测结果并输出' && modelType == 2">
          <p><i class="text-blue">def</i> <i class="text-pink">proposal_layer</i> <i class="text-navy-blue">(</i> rpn_cls_prob, rpn_bbox_pred, im_info, cfg_key, _feat_stride, anchors, num_anchors <i class="text-navy-blue">) ：</i></p>
          <p>......</p>
          <p class="text-green"># 获取预测值和置信度</p>
          <p>scores <i class="text-navy-blue">=</i> rpn_cls_prob<span class="text-navy-blue">[:, :, :, <i class="text-white">num_anchors</i>:]</span></p>
          <p>rpn_bbox_pred <i class="text-navy-blue">=</i> rpn_bbox_pred.reshape <span class="text-navy-blue">((-<i class="text-red">1</i><i class="text-white">,</i> <i class="text-red">4</i>))</span></p>
          <p>scores <i class="text-navy-blue">=</i> scores.reshape <span class="text-navy-blue">((-<i class="text-red">1</i><i class="text-white">,</i> <i class="text-red">1</i>))</span></p>
          <p>proposals <i class="text-navy-blue">=</i> bbox_transform_inv <i class="text-navy-blue">(</i>anchors, rpn_bbox_pred<i class="text-navy-blue">)</i></p>
          <p>proposals <i class="text-navy-blue">=</i> clip_boxes <span class="text-navy-blue">(<i class="text-white">proposals, im_info</i>[:<i class="text-red">2</i>])</span></p>
          <p class="text-green"># 获取顶层区域置信度</p>
          <p>order <i class="text-navy-blue">=</i> scores.ravel<i class="text-navy-blue">( )</i>.argsort<span class="text-navy-blue">( )[::-<i class="text-red">1</i>]</span></p>
          <p><i class="text-blue">if</i> pre_nms_topN <span class="text-navy-blue">> <i class="text-red">0</i>:</span></p>
          <p>    order <i class="text-navy-blue">=</i> order<i class="text-navy-blue">[:</i>pre_nms_topN<i class="text-navy-blue">]</i></p>
          <p>proposals <i class="text-navy-blue">=</i> proposals<i class="text-navy-blue">[</i>order, <i class="text-navy-blue">:]</i></p>
          <p>scores <i class="text-navy-blue">=</i> scores<i class="text-navy-blue">[</i>order<i class="text-navy-blue">]</i></p>
          <p>......</p>
          <p><i class="text-blue">return</i> blob, scores</p>
          <p></p>
          <p><i class="text-blue">def</i> <i class="text-pink">evaluate</i> <i class="text-navy-blue">(</i></p>
          <p>self,</p>
          <p>x <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 输入图像数据</i></p>
          <p>y <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 目标数据</i></p>
          <p>batch_size <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 批数</i></p>
          <p>verbose <i class="text-navy-blue">=</i> <i class="text-red">1</i>, <i class="text-green"># 信息复杂度模式，默认为1</i></p>
          <p>sample_weight <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 样本权重</i></p>
          <p>steps <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 步数</i></p>
          <p>callbacks <i class="text-navy-blue">=</i> <i class="text-blue">None</i>, <i class="text-green"># 回调</i></p>
          <p>max_queue_size <i class="text-navy-blue">=</i> <i class="text-red">10</i>, <i class="text-green"># 队列最大值</i></p>
          <p>workers <i class="text-navy-blue">=</i> <i class="text-red">1</i>, <i class="text-green"># 进程数</i></p>
          <p>use_multiprocessing <i class="text-navy-blue">=</i> <i class="text-blue">False</i>, <i class="text-green"># 是否多进程处理</i></p>
          <p>return_dict <i class="text-navy-blue">=</i> <i class="text-blue">False</i></p>
          <p class="text-navy-blue">) : <i class="text-green"># 返回值是否为dict形式</i></p>
        </div>
      </div>
      <div class="upper-lower-button">
        <el-button type="primary" @click="onLastStep">上一步</el-button>
        <el-button type="primary" @click="onNextStep">{{currentProcess==='预测结果并输出'?'我知道了':'下一步'}}</el-button>
      </div>
      <!-- <el-checkbox
        class="check-box"
        v-model="verificationNoTips"
        @change="verificationNoTipsChange"
        >下次不再提示</el-checkbox
      > -->
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'VerificationModelProcess',
  components: { },
  props: {
    modelType: {
      type: String,
      default: '1' // 1图像分类，2图像检测，3文本分类，4文本标注
    }
  },
  data() {
    return {
      currentProcess: '数据归一化',
      verificationNoTips: false,
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.modelType == 1 || this.modelType == 2 || this.modelType == 5 || this.modelType == 6) {
      this.currentProcess = '数据归一化'
    } else {
      this.currentProcess = '导入模型'
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  methods: {
    onSelectProcess(val) {
      this.currentProcess = val
    },
    // 上一步
    onLastStep() {
      if (this.currentProcess === '预测结果并输出') {
        this.currentProcess = '导入模型'
      } else if (this.currentProcess === '导入模型') {
        if (this.modelType == 1 || this.modelType == 2 || this.modelType == 5 || this.modelType == 6) {
          this.currentProcess = '数据归一化'
        } else {
          this.$emit('toVerificationModelPage')
        }
      } else if (this.currentProcess === '数据归一化') {
        this.$emit('toVerificationModelPage')
      }
    },
    // 下一步
    onNextStep() {
      if (this.currentProcess === '数据归一化') {
        this.currentProcess = '导入模型'
      } else if (this.currentProcess === '导入模型') {
        this.currentProcess = '预测结果并输出'
      } else if (this.currentProcess === '预测结果并输出') {
        // this.$emit('startVerification')
        this.$emit('toVerificationModelPage')
      } 
    },
    verificationNoTipsChange(val) {
      this.verificationNoTips = val
      if (this.modelType == 1) {
        window.localStorage.setItem('__verification_noTips_one__', val)
      } else if (this.modelType == 2) {
        window.localStorage.setItem('__verification_noTips_two__', val)
      } else if (this.modelType == 3) {
        window.localStorage.setItem('__verification_noTips_three__', val)
      } else if (this.modelType == 4) {
        window.localStorage.setItem('__verification_noTips_four__', val)
      } else if (this.modelType == 5) {
        window.localStorage.setItem('__verification_noTips_five__', val)
      } else if (this.modelType == 6) {
        window.localStorage.setItem('__verification_noTips_six__', val)
      }
      // this.localStorageVerificationNoTips('save', val)
    },
    localStorageVerificationNoTips(type, val) {
      if (type === 'save') {
        this.verificationNoTips = value
        window.localStorage.setItem('__verification_noTips__', value)
      } else {
        let verificationNoTips = window.localStorage.getItem('__verification_noTips__')
        this.verificationNoTips = verificationNoTips ? verificationNoTips : false
      }
    }
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.verification-model-process {
  width: 1020px;
  // height: 500px;
  height: 530px;
  background: #fff;
  position: absolute;
  top: -70px;
  left: -20px;
  z-index: 1;
  .verification-model-process-header {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #E6E9F2;
    padding: 0 20px;
    display: flex;
    align-items: center;
    .line {
      width: 4px;
      height: 17px;
      background: #4C88FF;
      margin-right: 10px;
    }
    .title {
      color: #333333;
      font-size: 18px;
      font-weight: 400;
    }
  }
  .verification-model-process-content {
    padding: 25px 70px 0;
    ul {
      height: 40px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      li {
        height: 40px;
        box-sizing: border-box;
        min-width: 110px;
        font-size: 15px;
        color: #000000;
        border-top: 1px solid #D9DEEA;
        border-left: 1px solid #D9DEEA;
        border-right: 1px solid #D9DEEA;
        border-radius: 5px 5px 0 0;
        // float: left;
        padding: 0px 20px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .icon-right-arrow {
        width: 13px;
        height: 9px;
        background: url("../../assets/images/icon-right-arrow.png") no-repeat;
        margin: 0 2px;
      }
      .current-process {       
        color: #FFFFFF;
        background: #4C88FF;
      }
    }

    .content-text {
      width: 871px;
      height: 280px;
      // background: #FFFFFF;
      background: rgba(0, 0, 0, 0.9);
      border: 1px solid #D9DEEA;
      padding: 15px 30px;
      overflow: auto;
      

      // &::-webkit-scrollbar {
      //   width: 10px; /*滚动条宽度*/
      //   height: 10px; /*滚动条高度*/
      // }

      // /*定义滚动条轨道 内阴影+圆角*/
      // &::-webkit-scrollbar-track {
      //   // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      //   // border-radius: 10px; /*滚动条的背景区域的圆角*/
      //   // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
      // }

      // /*定义滑块 内阴影+圆角*/
      // &::-webkit-scrollbar-thumb {
      //   border-radius: 3px; /*滚动条的圆角*/
      //   // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      //   // background: rgba(0, 96, 255, 0.1); /*滚动条的背景颜色*/
      //   background: #4C88FF; /*滚动条的背景颜色*/
      // }

      p {
        color: #fff;
        // color: #333333;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 26px;
      }

      .content-text-two,
      .content-text-three {
        p:nth-child(n+2) {
          text-indent: 2em;
        }
        p:nth-child(17) {
          height: 20px;
        }
        p:nth-child(18) {
          text-indent: 0em;
        }
      }

      i {
        color: #fff;
        font-style: normal;
      }

      .text-white {
        color: #fff;
      }

      .text-blue {
        color: #3A90FF;
      }
      .text-pink {
        // color: #FFB6FF;
        color: #FF66FF;
      }
      .text-green {
        color: #3AAD66;
      }
      .text-red {
        color: #FF3A3A;
      }
      .text-navy-blue {
        color: #0066B6;
      }
      .text-greyish-white {
        color: #696969;
      }
    }

    .upper-lower-button {
      text-align: center;
      margin: 10px 0;
      .el-button {
        width: 70px;
        height: 30px;
        background: #4C88FF;
        border-radius: 3px;
        padding: 0;
      }
    }

    .el-checkbox{
      margin-left: -22px;
    } 
    ::v-deep.el-checkbox__inner {
      border: 1px solid #606266;
      border-radius: 50%;
    }
    .is-checked {
      ::v-deep.el-checkbox__inner {
        border: 1px solid #4c88ff;
      }
    }
  }
}
</style>
